export class LastPackageReportMetadata {
    constructor(wt = 0, length = 0, width = 0, height = 0, eventTime = '', trackingId = '') {
        this.wt = wt;
        this.length = length;
        this.width = width;
        this.height = height;
        this.eventTime = eventTime;
        this.trackingId = trackingId;
    }
}


export class ReportMetadata {
    constructor(count = 0, maxWt = 0, avgWt = 0, totalWt = 0, heavyCount = 0) {
        this.count = count;
        this.maxWt = maxWt;
        this.avgWt = avgWt;
        this.totalWt = totalWt;
        this.heavyCount = heavyCount;
    }
}

export class OVReportMetadata {
    constructor(count = 0, maxWt = 0, avgWt = 0, totalWt = 0, nonConveyableCount = 0, heaviestNonConveyable = 0, totalNonConveyableWeight = 0, heavyCount = 0, heighestDimension = 0, heighestDimesnsionPackageWeight = 0) {
        this.count = count;
        this.maxWt = maxWt;
        this.avgWt = avgWt;
        this.totalWt = totalWt;
        this.nonConveyableCount = nonConveyableCount;
        this.heaviestNonConveyable = heaviestNonConveyable;
        this.totalNonConveyableWeight = totalNonConveyableWeight;
        this.heavyCount = heavyCount;
        this.heighestDimension = heighestDimension;
        this.heighestDimesnsionPackageWeight = heighestDimesnsionPackageWeight;
    }
}


export class ContainerReportMetadata {
    constructor(bagCount = 0, packageCount = 0, maxBagWt = 0, maxPackageWt = 0, avgBagWt = 0, totalWt = 0, avgPackageWt = 0) {
        this.bagCount = bagCount;
        this.packageCount = packageCount;
        this.maxBagWt = maxBagWt;
        this.maxPackageWt = maxPackageWt;
        this.avgBagWt = avgBagWt;
        this.totalWt = totalWt;
        this.avgPackageWt = avgPackageWt;
    }
}

export class Cart {
    constructor(maxBagWt = 0, cartWt = 0, bagCount = 0) {
        this.maxBagWt = maxBagWt;
        this.cartWt = cartWt;
        this.bagCount = bagCount;
    }
}




// WEBPACK FOOTER //
// ./src/components/detailPages/associateDetails/safetyReport/ReportViewSchema.js